import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ExecutionContextService } from 'src/core/context/execution-context.service';
import { ProfileNavigationService } from 'src/core/navigation/profile-navigation.service';

/**
 * Entry point técnico para URLs legacy que un operador puede visitar.
 * La autorización continúa en AuthGuardService; este componente solo conserva
 * una ruta válida para que Angular pueda ejecutar los guards antes de navegar.
 */
@Component({
  selector: 'app-operator-route-redirect',
  template: '',
  standalone: false,
})
export class OperatorRouteRedirectComponent implements OnInit {
  constructor(
    private readonly router: Router,
    private readonly executionContext: ExecutionContextService,
    private readonly profileNavigation: ProfileNavigationService
  ) {}

  ngOnInit(): void {
    const context = this.executionContext.getAuthenticated();
    void this.router.navigateByUrl(this.profileNavigation.getDefaultRoute(context));
  }
}
